import React from 'react';
import { Container } from './styles';
import HandleOrganizer from 'common/HandleOrganizer';

const ChooseOrganizer = (): JSX.Element => {
  return (
    <Container>
      <HandleOrganizer />
    </Container>
  );
};

export default ChooseOrganizer;
